import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Drawer } from './drawer';
import { Header } from './header';
const StyledDrawer = styled(Drawer)`
  /* .ant-drawer-header {
    padding: 0;
  }

  .ant-drawer-close {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
  }
  .ant-drawer-body {
    padding: 0;
  } */
  .ant-drawer-header,
  .ant-drawer-header-no-title {
    position: absolute;
    width: 100%;
    background: transparent;
    border: none;
    padding: 0;
  }

  .ant-drawer-title {
    display: none;
  }

  .ant-drawer-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
  }

  .ant-drawer-body {
    padding: 0;
  }
`;
const DrawerBody = styled.div`
  padding: var(--spacing-06);
`;
export const OzoneDrawer = ({ title, subTitle, children, subTitleColor, subTitlePlacement = 'bottom', headerStyle, ...rest })=>/*#__PURE__*/ _jsxs(StyledDrawer, {
        ...rest,
        title: null,
        children: [
            /*#__PURE__*/ _jsx(Header, {
                title: title,
                subTitle: subTitle,
                subTitleColor: subTitleColor,
                subTitlePlacement: subTitlePlacement,
                headerStyle: headerStyle
            }),
            /*#__PURE__*/ _jsx(DrawerBody, {
                className: "drawer__body",
                children: children
            })
        ]
    });
